import { jsx as _jsx } from "preact/jsx-runtime";
export default function ProjectTeasers({ projects }) {
    return (_jsx("ul", Object.assign({ className: "project-finder__teasers project-teasers" }, { children: projects.map(({ innerHtml, url }) => (_jsx("li", { className: "project-teaser", dangerouslySetInnerHTML: { __html: innerHtml }, onClick: () => (window.location.href = url) }, void 0))) }), void 0));
}
